class ProductBundle extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.videoPlayer = null;
    this.checkYTInterval = null;
  }

  connectedCallback() {
    this.initYouTubePlayer();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  cleanup() {
    if (this.checkYTInterval) {
      clearInterval(this.checkYTInterval);
      this.checkYTInterval = null;
    }
    if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
      this.videoPlayer.destroy();
    }
    this.videoPlayer = null;
  }

  initYouTubePlayer() {
    const videoContainer = this.querySelector('.product-bundle__video-container');
    const playerElement = this.querySelector(`#player-${this.sectionId}`);
    
    if (!videoContainer || !playerElement) return;

    // Load YouTube API if not already loaded
    if (!window.YT) {
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    // Wait for YouTube API to be ready
    this.checkYTInterval = setInterval(() => {
      if (window.YT && window.YT.Player) {
        clearInterval(this.checkYTInterval);
        this.createVideoPlayer(playerElement);
      }
    }, 100);

    setTimeout(() => {
      if (this.checkYTInterval) {
        clearInterval(this.checkYTInterval);
      }
    }, 10000);
  }

  createVideoPlayer(playerElement) {
    const videoContainer = this.querySelector('.product-bundle__video-container');
    const videoId = videoContainer?.dataset.videoId;
    
    if (!videoId) {
      return;
    }

    try {
      this.videoPlayer = new YT.Player(playerElement.id, {
        height: '100%',
        width: '100%',
        videoId: videoId,
        playerVars: {
          'playsinline': 1,
          'rel': 0,
          'autoplay': 0
        },
        events: {
          'onReady': () => {
            // Player is ready
          }
        }
      });
    } catch (e) {
      console.warn('Failed to create YouTube player:', e);
    }
  }
}

if (!customElements.get('product-bundle')) {
  customElements.define('product-bundle', ProductBundle);
}
